/* Maddie & Ko — custom-photo.js (ADDED FILE, preview only)
   Live photo preview + order summary for the custom photo product form.
   Works with a normal (non-AJAX) POST to /cart/add so the uploaded file
   is attached to the line item as a Shopify line item property. */
(function () {
  'use strict';

  function handle(s) {
    return String(s || '').toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function propName(n) { var m = /^properties\[(.+)\]$/.exec(n || ''); return m ? m[1] : null; }


  /* Laser-engraving preview: grayscale → reduced contrast → Floyd–Steinberg dither,
     drawn as one tone (dark burn on wood, light etch on slate) with soft edges,
     on a transparent layer so the wood/slate texture shows through. */
  function etchMode(stage) {
    if (!stage) return null;
    var c = stage.classList;
    if (c.contains('kind-slate') || (c.contains('kind-ornament') && c.contains('v-slate'))) return 'slate';
    if (c.contains('kind-wood') || c.contains('kind-ornament')) return c.contains('v-walnut') ? 'walnut' : 'wood';
    return null;
  }
  function etch(img, mode, boxW, boxH, round) {
    var W = Math.max(60, Math.round(boxW / 2.2)), H = Math.max(60, Math.round(boxH / 2.2));
    var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
    var cx = cv.getContext('2d');
    var s = Math.max(W / img.naturalWidth, H / img.naturalHeight);
    var dw = img.naturalWidth * s, dh = img.naturalHeight * s;
    cx.filter = 'blur(0.5px)';
    cx.drawImage(img, (W - dw) / 2, (H - dh) / 2, dw, dh);
    var d = cx.getImageData(0, 0, W, H), px = d.data, n = W * H, g = new Float32Array(n), lo = 1, hi = 0, i;
    for (i = 0; i < n; i++) { var v = (0.299 * px[i * 4] + 0.587 * px[i * 4 + 1] + 0.114 * px[i * 4 + 2]) / 255; g[i] = v; if (v < lo) lo = v; if (v > hi) hi = v; }
    var span = Math.max(0.05, hi - lo), soft = new Float32Array(n);
    for (i = 0; i < n; i++) { var t = Math.min(1, Math.max(0, (g[i] - lo) / span)); t = 0.12 + 0.78 * Math.pow(t, 1.1); g[i] = t; soft[i] = t; }
    for (var y = 0; y < H; y++) for (var x = 0; x < W; x++) {
      i = y * W + x; var o = g[i]; if (!(o === o)) o = soft[i]; var q = o < 0.5 ? 0 : 1, e = o - q; g[i] = q;
      if (x + 1 < W) g[i + 1] += e * 7 / 16;
      if (y + 1 < H) { if (x > 0) g[i + W - 1] += e * 3 / 16; g[i + W] += e * 5 / 16; if (x + 1 < W) g[i + W + 1] += e / 16; }
    }
    var col = mode === 'slate' ? [222, 220, 215] : mode === 'walnut' ? [32, 18, 9] : [78, 44, 22];
    var f = 0.08 * Math.min(W, H);
    for (y = 0; y < H; y++) for (x = 0; x < W; x++) {
      i = y * W + x;
      var light = 0.7 * g[i] + 0.3 * soft[i];
      var amt = mode === 'slate' ? light : 1 - light;
      var edge;
      if (round) { var r = Math.min(W, H) / 2, dd = Math.sqrt(Math.pow(x - W / 2, 2) + Math.pow(y - H / 2, 2)); edge = Math.min(1, Math.max(0, (r - dd) / (f * 1.6))); }
      else edge = Math.min(1, Math.min(x, y, W - 1 - x, H - 1 - y) / f);
      var a = Math.max(0, Math.min(1, amt * edge * (mode === 'slate' ? 0.85 : 0.9)));
      px[i * 4] = col[0]; px[i * 4 + 1] = col[1]; px[i * 4 + 2] = col[2]; px[i * 4 + 3] = Math.round(a * 255);
    }
    cx.putImageData(d, 0, 0);
    return cv.toDataURL('image/png');
  }

  function init(root) {
    var form = root.querySelector('form');
    var stage = root.querySelector('.cp-stage');
    var fileInput = root.querySelector('input[type=file][data-cp-photo]');
    var drop = root.querySelector('.cp-drop');
    var status = root.querySelector('.cp-file-status');
    var photo = root.querySelector('.cp-photo');
    var blank = root.querySelector('.cp-blank');
    var tN = root.querySelector('.cp-text .n');
    var tD = root.querySelector('.cp-text .d');
    var approve = root.querySelector('[data-cp-approve]');
    var btn = root.querySelector('.add-to-cart');
    var summary = root.querySelector('[data-cp-summary]');
    var maxMb = parseFloat(root.getAttribute('data-max-mb') || '20');
    var minPx = parseInt(root.getAttribute('data-min-px') || '1200', 10);
    var photoRequired = fileInput && fileInput.hasAttribute('required');
    var fileInfo = null;
    var origImg = null, origSrc = '', lastMode = '';
    var baseClass = stage ? stage.className.replace(/\s*v-[a-z0-9-]+/g, '').replace(/\s*font-[a-z]+/g, '') : '';

    function selectedPills() {
      var out = [];
      root.querySelectorAll('.option-pill.active').forEach(function (p) {
        out.push({ name: p.getAttribute('data-option-name') || ('Option ' + p.getAttribute('data-option-position')), value: p.getAttribute('data-option-value') });
      });
      return out;
    }

    function refreshStage() {
      if (!stage) return;
      var cls = [baseClass];
      selectedPills().forEach(function (o) { cls.push('v-' + handle(o.value)); });
      root.querySelectorAll('[data-cp-mod]').forEach(function (el) {
        if (el.type === 'radio' && !el.checked) return;
        if (el.value) cls.push('v-' + handle(el.value));
      });
      var font = root.querySelector('[data-cp-font]');
      if (font) cls.push('font-' + (font.options ? font.options[font.selectedIndex].getAttribute('data-font') || 'serif' : 'serif'));
      else cls.push('font-serif');
      stage.className = cls.join(' ');
      renderPhoto();
      var nEl = root.querySelector('[data-cp-text=n]');
      var dEl = root.querySelector('[data-cp-text=d]');
      if (tN) tN.textContent = nEl && nEl.value ? nEl.value : (nEl ? nEl.getAttribute('placeholder') || '' : '');
      if (tD) tD.textContent = dEl && dEl.value ? dEl.value : (dEl ? dEl.getAttribute('placeholder') || '' : '');
    }


    function renderPhoto() {
      if (!photo || !origSrc) return;
      var mode = origImg ? etchMode(stage) : null;
      var key = mode + '|' + origSrc.length;
      if (key === lastMode) return;
      lastMode = key;
      if (!mode) { photo.classList.remove('cp-etched'); photo.src = origSrc; return; }
      try {
        var win = photo.parentNode, r = win.getBoundingClientRect();
        var w = r.width || 400, h = r.height || 320;
        photo.src = etch(origImg, mode, w * 1.5, h * 1.5, stage.classList.contains('kind-ornament'));
        photo.classList.add('cp-etched');
      } catch (err) { photo.classList.remove('cp-etched'); photo.src = origSrc; }
    }

    function counters() {
      root.querySelectorAll('[maxlength][data-cp-count]').forEach(function (el) {
        var c = root.querySelector('[data-count-for="' + el.id + '"]');
        if (c) c.textContent = el.value.length + ' / ' + el.getAttribute('maxlength');
      });
    }

    function refreshSummary() {
      if (!summary) return;
      var rows = [];
      var type = root.getAttribute('data-kind-label');
      if (type) rows.push(['Product type', type]);
      selectedPills().forEach(function (o) { rows.push([o.name, o.value]); });
      var q = form.querySelector('input[name=quantity]');
      if (q) rows.push(['Quantity', q.value]);
      form.querySelectorAll('[name^="properties["]').forEach(function (el) {
        var n = propName(el.name);
        if (!n || n.charAt(0) === '_') return;
        if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) {
          if (el.type === 'checkbox') rows.push([n, null]);
          return;
        }
        if (el.type === 'file') {
          rows.push([n, fileInfo ? fileInfo : null]);
          return;
        }
        rows.push([n, el.value ? el.value : null]);
      });
      var seen = {};
      summary.innerHTML = rows.filter(function (r) { if (seen[r[0]] && r[1] === null) return false; seen[r[0]] = 1; return true; }).map(function (r) {
        return '<dt>' + esc(r[0]) + '</dt>' + (r[1] === null ? '<dd class="empty">not provided</dd>' : '<dd>' + esc(r[1]) + '</dd>');
      }).join('');
    }

    function gate() {
      if (!btn) return;
      var ok = (!approve || approve.checked) && (!photoRequired || (fileInput.files && fileInput.files.length));
      var tooBig = fileInput && fileInput.files && fileInput.files[0] && fileInput.files[0].size > maxMb * 1048576;
      btn.disabled = !ok || tooBig || btn.hasAttribute('data-sold-out');
      var hint = root.querySelector('[data-cp-gate-hint]');
      if (hint) {
        var msgs = [];
        if (photoRequired && !(fileInput.files && fileInput.files.length)) msgs.push('upload your photo');
        if (approve && !approve.checked) msgs.push('check the approval box');
        if (tooBig) msgs.push('choose a photo under ' + maxMb + ' MB');
        hint.textContent = msgs.length ? 'To add to cart: ' + msgs.join(' and ') + '.' : 'Ready! Your photo uploads when you add to cart.';
      }
    }

    function all() { refreshStage(); counters(); refreshSummary(); gate(); }

    if (fileInput) {
      fileInput.addEventListener('change', function () {
        var f = fileInput.files && fileInput.files[0];
        fileInfo = null;
        if (!f) { origSrc = ''; origImg = null; lastMode = ''; blank && blank.classList.remove('has-photo'); status.textContent = ''; all(); return; }
        var mb = (f.size / 1048576).toFixed(1);
        fileInfo = f.name + ' (' + mb + ' MB)';
        status.className = 'cp-file-status';
        if (f.size > maxMb * 1048576) {
          status.className = 'cp-file-status warn';
          status.textContent = 'That file is ' + mb + ' MB. Please choose one under ' + maxMb + ' MB.';
        } else {
          status.textContent = '✓ ' + f.name + ' · ' + mb + ' MB';
        }
        var isHeic = /heic|heif/i.test(f.type) || /\.hei[cf]$/i.test(f.name);
        if (isHeic) {
          status.textContent += ' · iPhone HEIC photos upload fine, but can\'t preview in every browser.';
        }
        var reader = new FileReader();
        reader.onload = function (e) {
          origSrc = e.target.result; origImg = null; lastMode = '';
          var im = new Image();
          im.onload = function () {
            var w = im.naturalWidth, h = im.naturalHeight;
            if (w && h) {
              fileInfo = f.name + ' (' + mb + ' MB, ' + w + '×' + h + ')';
              if (Math.max(w, h) < minPx) {
                status.className = 'cp-file-status warn';
                status.textContent += ' · Heads up: this photo is small (' + w + '×' + h + '). A larger original will engrave/print sharper.';
              }
            }
            origImg = im; lastMode = ''; renderPhoto();
            refreshSummary();
          };
          im.onerror = function () { renderPhoto(); };
          im.src = origSrc;
          photo.src = origSrc;
          blank && blank.classList.add('has-photo');
        };
        reader.readAsDataURL(f);
        all();
      });
      if (drop) {
        ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function () { drop.classList.add('drag'); }); });
        ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function () { drop.classList.remove('drag'); }); });
      }
    }

    root.addEventListener('input', all);
    root.addEventListener('change', all);
    root.addEventListener('click', function (e) { if (e.target.closest('.option-pill, .qty-input button')) setTimeout(all, 0); });

    form.addEventListener('submit', function (e) {
      gate();
      if (btn && btn.disabled) { e.preventDefault(); return; }
      if (root.hasAttribute('data-cp-mock')) {
        e.preventDefault();
        var ev = new CustomEvent('cp:mock-submit', { detail: { form: form } });
        root.dispatchEvent(ev);
        return;
      }
      if (btn) { btn.textContent = 'Uploading your photo…'; btn.setAttribute('aria-busy', 'true'); }
    });

    all();
  }

  window.MKCustomPhoto = { init: init };
  function boot() { document.querySelectorAll('[data-cp]:not([data-cp-manual])').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
